module.exports = __webpack_public_path__ + "static/media/phone-cht.0e1afd30.png";